<template>
  <div class="inspectionReport">
    <div class="inspectionContent">
      <!-- <div class="dataTitle">
        <van-icon
          class="hospiyalsArrowLeft"
          style="top: 16px;"
          name="arrow-left"
          @click="onBack"
          v-if="forwardingReport"
        />
        <div class="title">
          <div class="content action">检查报告</div>
          <div class="line">|</div>
      <div class="content" @click="toPortrait">数字影像</div>-->
      <!-- <div class="line" v-if="forwardingReport&&examId">|</div>
      <div class="content" @click="toForwarding" v-if="forwardingReport&&examId">转发报告</div>-->
      <!-- </div>
      </div>-->
      <div class="dataList" v-if="report">
        <div class="itemContent" v-for="(item, index) in infoData" :key="index">
          <ul class="info">
            <li class="header">
              <span v-if="item.type == 1">{{
                item.local_institution_name
              }}</span>
              <span v-if="item.type == 2">{{
                item.remote_institution_name
              }}</span>
              <span :id="`qrcode${index}`" class="white_QR"></span>
            </li>
            <li class="labelContent">
              <span class="label1">影像号：</span>
              <span class="content1">{{ item.accession_num }}</span>
              <span class="label2">姓名：</span>
              <span class="content2">{{ item.name }}</span>
            </li>
            <li class="labelContent">
              <span class="label1">检查时间：</span>
              <span class="content1">{{ item.exam_datetime }}</span>
              <span class="label2">性别：</span>
              <span class="content2" v-if="item.sex == 'M' || item.sex == '男'"
                >男</span
              >
              <span class="content2" v-if="item.sex == 'F' || item.sex == '女'"
                >女</span
              >
            </li>
            <li class="labelContent" v-if="item.institution_id === '06300007'">
              <span class="label1">年龄：</span>
              <span class="content1">{{ item.age }}</span>
              <span class="label2">申请科室：</span>
              <span class="content2">{{ item.application_department }}</span>
            </li>
            <li class="labelContent" v-if="item.institution_id === '06300007'">
              <span class="label1">住院号：</span>
              <span class="content1">{{ item.hopitalized_no }}</span>
              <span class="label2">床号：</span>
              <span class="content2">{{ item.bed_no }}</span>
            </li>
            <li class="labelContent" v-if="item.institution_id === '06300007'">
              <span class="label1">检查部位：</span>
              <span class="content1" style="width:80%;text-align-last: auto;">{{
                item.exam_project
              }}</span>
            </li>
            <li class="labelContent" v-else>
              <span class="label1">检查项目：</span>
              <span class="content1" style="width:80%;text-align-last: auto;">{{
                item.exam_project
              }}</span>
            </li>
            <li class="details">
              <div class="label" v-if="item.institution_id === '06300007'">
                影像学所见：
              </div>
              <div class="label" v-else>检查所见：</div>
              <div class="details_info">
                <span v-html="item.description"></span>
              </div>
              <div class="label" v-if="item.institution_id === '06300007'">
                影像学意见：
              </div>
              <div class="label" v-else>诊断意见：</div>
              <div class="details_info">
                <span v-html="item.impression"></span>
              </div>
            </li>
            <li class="food">
              <span class="label">报告:</span>
              <span class="content">{{ item.report_doctor_name }}</span>
              <span class="label">审核:</span>
              <span class="content">{{ item.review_doctor_name }}</span>
              <span class="label">确认:</span>
              <span class="content">{{ item.confirm_doctor_name }}</span>
            </li>
          </ul>
          <div class="reportDate">
            <span>报告时间:{{ item.report_datetime }}</span>
          </div>
        </div>
      </div>
      <div v-if="noreports" class="white_title">暂无报告</div>
      <div
        class="allReport"
        @click="toReportList"
        v-if="Storage.get('reportPermissions') != 1"
      >
        < 全部报告
      </div>
      <!-- <footer class="footer" v-if="noreport">
          <div class="outreach" @click="insurance">
            医疗保险
            <img src="../../../../assets/arrow.png" alt />
          </div>
          <div class="outreach" @click="fundraising">
            大病众筹
            <img src="../../../../assets/arrow.png" alt />
          </div>
          </footer>-->
    </div>
    <div class="inspectionMontmorillonite" v-if="Montmorillonite">
      <div class="inspectionInputBox">
        <div class="inspectionInputBoxPrompt">提示</div>
        <div class="inspectionInputBoxContent">
          <div class="inspectionInputBoxContentTitle">
            请输入4位密码查看{{ xxx }}的检查报告
          </div>
          <div class="inspectionInputBoxContentPassword">
            输入密码：
            <input v-model="code" type="text" />
          </div>
        </div>
        <div class="inspectionInputBoxButton">
          <span @click="cencelMontmorillonite">确定</span>
        </div>
      </div>
    </div>
    <!-- 查看分享报告 关注公众号二维码浮层 -->
    <div class="attentionQRCode" v-if="!forwardingReport">
      <!-- <div class="attentionQRCode"> -->
      <div style="display:flex">
        <img class="logo" src="../../../../assets/login.png" alt />
        <p style="font-size:14px">中世康恺</p>
      </div>
      <p :style="{ fontSize: '12px' }">
        本服务由数字影像云提供，可关注公众号进一步了解详情
      </p>
      <img
        class="QRCodeImg"
        src="../../../../assets/QRcode.png"
        @click="show = true"
        alt
      />
    </div>
    <!-- 二维码弹窗 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <!--@click.stop-->
        <div class="block">
          <img class="modelQRCodeImg" src="../../../../assets/QRcode.png" />
          <p :style="{ fontWeight: 'bold', margin: '0px' }">
            公众号：数字影像云
          </p>
          <p :style="{ fontSize: '12px', color: '#707270', margin: '5px 0' }">
            长按识别
          </p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import Storage from "@/tools/storage";
import { getAllReport, getPatientInfo } from "@/api/reportOuter";
import { getReportByCode, getOneReport, getReportInfo } from "@/api/report";
import { wechatLogin } from "@/api/user";
import store from "@/store";
import QRCode from "qrcodejs2"; /* 生成二维码 */
export default {
  name: "inspectionReport",
  data() {
    return {
      xxx: Storage.get("makeReportLinkName"),
      infoData: [],
      Montmorillonite: false,
      code: "",
      forwardingReport: true,
      examId: true,
      report: false,
      noreport: false,
      noreports: false,
      show: false,
    };
  },
  filters: {
    qzCode(id, url) {
      let text = url;
      let QrCodes = document.getElementById("qrcode" + id);
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度
        text: text, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      let obtainImg = QrCodes.getElementsByTagName("img");
      let obtainCanvas = QrCodes.getElementsByTagName("canvas");
      obtainImg[0].style.width = 1 + "rem";
      obtainImg[0].style.height = 1 + "rem";
      obtainCanvas[0].style.width = 1 + "rem";
      obtainCanvas[0].style.height = 1 + "rem";
    },
  },
  methods: {
    /* 判断是否有内容 */
    initial() {
      if (!!this.$route.query.short) {
        Storage.set("share", this.$route.query.short);
      }
      // debugger;
      let shar = JSON.parse(Storage.get("share")) == null;
      if (shar) {
        // let examId = JSON.parse(Storage.get("reportInfo")).length;
        // if (!examId) {
        //   this.examId = false;
        // }
        getPatientInfo({
          exam_id: this.$route.query.exam_id,
        }).then((res) => {
          console.log(res);
          if (res.length) {
            
            Storage.set("reportInfo", res);
            Storage.set("studyId", res[0].study_id);
            console.log(res);
            this.infoData = res;
            if (res[0].exam_status == 9 || res[0].report_status == 9) {
              this.report = true;
              this.noreport = true;
              this.noreports = false;
            }
            if(res[0].pay_status === '0'){//未支付
              this.$router.push({
                path: "/reportListOuter_JX",
                query: { institution_id: res[0].institution_id, type: 1+','+2, code: `${res[0].patient_num}`+',' + res[0].accession_num }
              });
            }
          } else {
            this.report = false;
            this.noreport = false;
            this.noreports = true;
          }
        });
      } else {
        this.report = true;
        this.noreport = true;
        this.noreports = false;
      }
    },
    /* 二维码 */
    creatQrCode() {
      this.infoData = JSON.parse(Storage.get("reportInfo"));
      let data = JSON.parse(Storage.get("reportInfo"));

      setTimeout(() => {
        this.$nextTick(() => {
          for (let i = 0; i < data.length; i++) {
            let text = data[i].qr_code;
            let QrCodes = document.getElementById("qrcode" + i);
            let qrcode = new QRCode(QrCodes, {
              width: 100,
              height: 100, // 高度
              text: text, // 二维码内容
              // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
              // background: '#f0f'
              // foreground: '#ff0'
            });
            let obtainImg = QrCodes.getElementsByTagName("img");
            let obtainCanvas = QrCodes.getElementsByTagName("canvas");
            // console.info(obtainCanvas);
            obtainImg[0].style.width = 1 + "rem";
            obtainImg[0].style.height = 1 + "rem";
            obtainCanvas[0].style.width = 1 + "rem";
            obtainCanvas[0].style.height = 1 + "rem";
          }
        });
      }, 1000);
    },
    insurance() {
      window.location.href = "http://leo.spread.newtank.cn/group0930";
    },
    fundraising() {
      window.location.href =
        "https://www.shuidichou.com/luban/f45t2je2sard/1?channel=ad_search_sem&source=app_zkwx";
    },
    toPortrait() {
      this.$router.push({ path: "/reportInfoOuter/portrait" });
    },
    toReportList() {
      window.location.href =
        "https://wc4.pacsonline.cn/#/reportListOuter?institution_id=51000001&type=1&code=CT00053018";
      // this.$router.push({
      //   path: "/reportListOuter",
      //   query: { institution_id: "51000001", type: 1, code: "CT00053018" },
      // });
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1);
    },
    toForwarding() {
      this.$router.push({ path: "/reportInfoOuter/forwarding" });
    },
    async cencelMontmorillonite() {
      let params = { id: Storage.get("makeReportLinkId"), code: this.code };
      let res = await getReportByCode(params);
      if (res) {
        Storage.set("reportInfo", res);
        Storage.set("studyId", res[0].study_id);
        this.infoData = res;
        this.Montmorillonite = false;
        this.report = true;
      }
    },
    // async wechatLogin(reportId) {
    //   console.log(Storage.get('openid'))
    //   let that = this
    //   let params = { openid: Storage.get('openid') }
    //   let res = await wechatLogin(params)
    //   if (res) {
    //     store.dispatch('setToken', res.token)
    //     that.getOneReport()
    //   }
    // },
    async getOneReport() {
      let params = { id: Storage.get("reportId") };
      let res = await getOneReport(params);
      if (res) {
        let arr = [];
        arr.push(res);
        this.infoData = arr;
        Storage.set("reportInfo", arr);
        Storage.set("studyId", res.study_id);
      }
    },
  },
  mounted() {
    this.initial();
    this.creatQrCode();
  },
  created() {
    let url = window.location.href;
    if (url.indexOf("report_id=") != -1) {
      let reportId = url.match(/id=(\S*)&openid/)[1];
      let string = url.indexOf("openid=");
      let names = url.substring(string);
      let num = names.indexOf("=");
      let name = names.substring(num + 1);
      Storage.set("openid", name);
      Storage.set("reportId", reportId);
      // this.wechatLogin()
      // this.getOneReport();
      // alert(111)
    }
    if (url.indexOf("short=1") != -1) {
      if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
        let str = url.match(/id=(\S*)&short/)[1];
        Storage.set("makeReportLinkId", str);
        let string = url.indexOf("name=");
        let names = url.substring(string);
        let num = names.indexOf("=");
        let name = names.substring(num + 1);
        Storage.set("makeReportLinkName", decodeURI(name));
      }
      Storage.set("reportPermissions", 1);
      this.Montmorillonite = true;
    } else {
      this.Montmorillonite = false;
    }

    if (Storage.get("reportPermissions")) {
      this.forwardingReport = false;
    }
  },
};
</script>
<style lang="sass" scoped>
@import "../../../../style/reportInfo/index.css"
</style>
<style scoped>
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
  text-align: center;
}
.header {
  position: relative;
}
.white_QR {
  position: absolute;
  top: 0.4rem;
  right: 0;
}
.attentionQRCode .logo {
  width: 26px;
  height: 26px;
  display: inline-block;
  margin-right: 8px;
}
.attentionQRCode p {
  margin: 0;
}
.attentionQRCode .QRCodeImg {
  width: 80px;
  height: 80px;
  position: absolute;
  right: 25px;
  bottom: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
}
.block {
  width: 240px;
  height: 240px;
  background-color: #fff;
  text-align: center;
}
.wrapper .modelQRCodeImg {
  width: 150px;
  height: 150px;
  margin-top: 20px;
}
</style>
